const items = [
  {
    title: "Premium Quality",
    body: "We pay attention to every detail to ensure your workplace makes a perfect first impression.",
  },
  {
    title: "Eco-Friendly Approach",
    body: "We use high-quality, certified, and environmentally safe cleaning products.",
  },
  {
    title: "Consistent Quality",
    body: "Reliable service, clear communication, and consistent quality inspections.",
  },
];

export default function WhyAGS() {
  return (
    <section
      data-testid="why-ags-section"
      id="why-ags"
      className="bg-[#F4F8FC] py-28 md:py-40 border-t border-[#E5EBF2]"
    >
      <div className="container-ags">
        <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#0E2A57]/60 font-medium">
          05 — Why AGS Cleaning Services
        </span>
        <h2 className="mt-6 font-heading font-extrabold text-4xl md:text-6xl leading-[1.0] tracking-[-0.04em] text-[#050B14] max-w-4xl">
          Three reasons Irish facility managers <span className="italic-display font-normal text-[#0E2A57]">stay with us.</span>
        </h2>

        <div className="mt-16 divide-y divide-[#E5EBF2] border-t border-b border-[#E5EBF2]">
          {items.map((it, i) => (
            <div
              key={it.title}
              data-testid={`why-row-${i}`}
              className="grid grid-cols-12 gap-6 py-10 md:py-14 group transition-colors hover:bg-white"
            >
              <div className="col-span-12 md:col-span-1 font-mono text-[#475569] text-sm tracking-[0.18em]">
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="col-span-12 md:col-span-5 font-heading font-extrabold text-3xl md:text-5xl tracking-[-0.035em] text-[#050B14] group-hover:text-[#0E2A57] transition-colors">
                {it.title}
              </h3>
              <p className="col-span-12 md:col-span-6 text-[#475569] text-base md:text-lg leading-[1.6] self-center">
                {it.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
